import { useCallback, useEffect, useState } from "react";

// how many tiles a screen can carry before they get too small
const STOPS = [
  [640, 1],
  [900, 2],
  [1200, 3],
  [1500, 4],
  [1800, 5],
];

const maxFor = (w) => (STOPS.find(([px]) => w < px) || [0, 6])[1];

// Shopper-chosen tiles per row, clamped by what the screen can actually fit.
export const useGridCols = (key, fallback = 4) => {
  const [pick, setPick] = useState(
    () => Number(localStorage.getItem(key)) || fallback,
  );
  const [max, setMax] = useState(() => maxFor(window.innerWidth));

  useEffect(() => {
    const onResize = () => setMax(maxFor(window.innerWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const choose = useCallback(
    (n) => {
      setPick(n);
      localStorage.setItem(key, String(n));
    },
    [key],
  );

  return { cols: Math.min(pick, max), pick, choose, max };
};

export const COL_CHOICES = [1, 2, 3, 4, 5, 6];
